import { AutocompleteRenderOptionState } from '@material-ui/lab';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as React from 'react';
import { isEqual } from 'lodash';
import i18n from '../../../common/i18n';
import { AutocompleteFilterInput } from './AutocompleteFilterInput';

export const FilterAutoComplete = ({
    value,
    options,
    onChange,
    inputValue,
    onInputChange,
    renderOption
}: {
    value;
    options;
    onChange;
    inputValue;
    onInputChange;
    renderOption: (option, state: AutocompleteRenderOptionState) => React.ReactNode;
}) => {
    return (
        <Autocomplete
            open={true}
            value={value}
            onChange={onChange}
            inputValue={inputValue}
            onInputChange={onInputChange}
            disableClearable={true}
            PaperComponent={({ className, ...other }) => <div {...other} />}
            PopperComponent={({ disablePortal, open, anchorEl, ...other }) => <div {...other} />}
            noOptionsText={i18n('nui.search.no-results')}
            renderOption={renderOption}
            options={options}
            getOptionLabel={option => option?.value}
            renderInput={params => <AutocompleteFilterInput {...params} />}
            getOptionSelected={(option, value) => isEqual(option.value, value.value)}
        />
    );
};
